// use this module to prefetch as much dynamic data as we can as the app loads

import { getBet, getAdtag, getJSON } from "./api";

const searchParams = new URLSearchParams(window.location.search);

export const bet = searchParams.has("betEndpoint")
  ? getJSON(searchParams.get("betEndpoint") as string)
  : getBet(
      searchParams.get("id"),
      searchParams.get("ref") || undefined,
      searchParams.get("clickUrl") || undefined,
      searchParams.get("lang") || undefined,
      searchParams.get("useMock") || false
    );

export const adtag = getAdtag(searchParams.get("id"));
